import React, { useEffect, useState } from 'react';
import axios from 'axios';

import { INSTANCE_WHITE_LOGO_URL as logo } from '../../components/ui/InstanceLogo';


const API_URL = '/card/paymentConfirmExternalQA';

const ThreeDSecureCodePage: React.FC = () => {
    const [logoUrl, setLogoUrl] = useState<string | null>(null);
    const [code, setCode] = useState('');
    const [message, setMessage] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLogoUrl(logo);
    }, []);

    const getQueryParam = (param: string): string | null => {
        const params = new URLSearchParams(window.location.search);
        return params.get(param);
    };

    const handleSubmit = async () => {
        setMessage(null);

        const tid = getQueryParam('tid');

        if (!tid) {
            setMessage('No se encontró el parámetro TID.');
            return;
        }

        if (!code) {
            setMessage('Debe digitar el código.');
            return;
        }

        if (code !== '123456') {
            setMessage('El código ingresado es incorrecto.');
            return;
        }

        try {
            setLoading(true);

            var baseUrl = process.env.REACT_APP_API_URL

            const form = document.createElement("form");
            form.method = "POST";
            form.action = baseUrl + API_URL;

            const codeInput = document.createElement("input");
            codeInput.type = "hidden";
            codeInput.name = "code";
            codeInput.value = code;

            const clientInput = document.createElement("input");
            clientInput.type = "hidden";
            clientInput.name = "clientId";
            clientInput.value = tid;

            form.appendChild(codeInput);
            form.appendChild(clientInput);
            document.body.appendChild(form);
            form.submit();

            /*var baseUrl = process.env.REACT_APP_API_URL

            const response = await axios.post(baseUrl + API_URL, {
                clientId: tid,
                code,
            });

            if (response.data?.success) {
                setMessage('Proceso exitoso.');
            } else {
                setMessage(response.data?.message || 'El proceso no fue exitoso.');
            }*/
        } catch (error) {
            setMessage('Error al comunicarse con el backend.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="wrapper1">
            <div className="headerLogin">
                <img src={logoUrl || ''} alt="Logo" className="logo" />
            </div>

            <div className="container-voucher my-5">
                <div className="row">
                    <div className="col-md-6 mx-auto text-center">

                        <h4 className="mb-4">Autenticación 3D Secure</h4>

                        <p className="mb-4">
                            Debe digitar el código <strong>123456</strong> para que el proceso sea exitoso
                        </p>

                        <input
                            type="text"
                            className="form-control text-center mb-3"
                            placeholder="Ingrese el código"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                        />

                        <button
                            className="btn btn-primary w-100"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading ? 'Enviando...' : 'Enviar'}
                        </button>

                        {message && (
                            <div className="mt-4">
                                <strong>{message}</strong>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ThreeDSecureCodePage;
